<template lang="pug">
footer
  .provider
    ul.list-inline.mb-0.text-center
      li.list-inline-item
        img(src='img/provider/03.png')
      li.list-inline-item
        img(src='img/provider/04.png')
      li.list-inline-item
        img(src='img/provider/05.png')
      li.list-inline-item
        img(src='img/provider/06.png')
      li.list-inline-item
        img(src='img/provider/07.png')
      li.list-inline-item
        img(src='img/provider/09.png')
      li.list-inline-item
        img(src='img/provider/08.png')
      li.list-inline-item
        img(src='img/provider/01.png')
      li.list-inline-item
        img(src='img/provider/02.png')
      li.list-inline-item
        img(src='img/provider/10.png')
</template>
<script>
export default {
  mounted(){

  },
  methods:{

  }
}
</script>
